import { HierarchyBuilder } from '~/utils/literature/hierarchy-builder'

export function useHierarchy(bookId: MaybeRefOrGetter<string>) {
  const { data, suspense } = useSolrQueryV2(
    computed(() => ({ bookHierarchy: toValue(bookId) })),
    'page',
    'literature',
    { cache: true },
  )

  const { $parseStringToDocument } = useNuxtApp()

  const builder = new HierarchyBuilder($parseStringToDocument)

  return {
    data: computed(() => builder.buildEnhancedHierarchy(data.value?.response.docs ?? [])),
    suspense,
  }
}
